import classnames from 'classnames';
import React, { FC, MouseEventHandler, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { Button } from 'uikit/Button';
import { Heading2 } from 'uikit/Heading';
import { TextP3 } from 'uikit/Text';

import './CallToActionSection.scss';

type Props = {
  className?: string;
  tagline?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action: ReactNode;
  href: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
};

const CallToActionSection: FC<Props> = (props) => {
  const { tagline, children } = props;

  const hostCN = classnames('callToActionSection', props.className);

  return (
    <section className={hostCN}>
      <div className="container">
        {tagline && (
          <TextP3 dark className="callToActionSection__tagline">
            {props.tagline}
          </TextP3>
        )}
        <Heading2>{props.title}</Heading2>
        {children && <div className="callToActionSection__content">{children}</div>}
        <Link to={props.href} onClick={props.onClick} className="callToActionSection__action">
          <Button kind="secondary" width="full" as="span" className="callToActionSection__button">
            {props.action}
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default CallToActionSection;
